import React from "react";
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons";
import {HorizontalLoader, InfiniteScroll, Loader, ScrollableCard} from "@mc/mc-legacy";
import ListItem from "./ListItem";
import {withRouter} from "react-router";
import "./ItemList.scss";
import MessageEmptyList from "./MessageEmptyList";

const ItemList = (props) => {
    let {itemList, renderItem, emptyList, mobil, md} = props;

    if (!itemList.fetched) {
        return <Loader/>;
    }

    if (itemList.count === 0) {
        return emptyList;
    }

    return (

        <ScrollableCard key="scroll-card" detail className="inverse item-list h-100">
            <InfiniteScroll
                className={"items-box"}
                bordered
                loadMore={() => props.dispatch(props.loadMore())}
                hasMore={itemList.hasMore}
            >
                {itemList.isFetching && <HorizontalLoader key={'loader'} hover/>}
                {itemList.rows.map((item, detail) => {
                    return (
                        <div key={item.id}>
                            <ListItem md={md} item={item}>
                                {renderItem(item, faFilePdf)}
                            </ListItem>
                        </div>
                    );
                })}
            </InfiniteScroll>
        </ScrollableCard>

    );
};

ItemList.propTypes = {
    itemList: PropTypes.object,
    //store listu
    loadMore: PropTypes.func.isRequired,
    renderItem: PropTypes.func.isRequired,
    renderActions: PropTypes.func.isRequired,
    emptyList: PropTypes.object,
};
ItemList.defaultProps = {
    emptyList: <MessageEmptyList/>,
};

function mapStateToProps(state, props) {
    return {};
}

export default connect(mapStateToProps)(withRouter(ItemList));
